module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    staticClass: "sidebar",
    attrs: {
      "span": 6
    }
  }, [_c('ListFilterComponent', {
    attrs: {
      "allowDeselect": false,
      "selectedFilters": _vm.filters.selected,
      "listFilters": _vm.filters.available
    },
    on: {
      "setFilter": _vm.setFilter
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "box",
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "list__header"
  }, [_c('p', {
    staticClass: "list__title"
  }, [_vm._v("\n                    " + _vm._s(_vm.getRouteName(_vm.$route)) + "\n                    "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Złap i przeciągnij")]), _vm._v(" "), _c('el-button', {
    staticClass: "alphabetically-sort-button",
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.sortAlphabetically
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-asc"
  }), _vm._v(" Przesortuj alfabetycznie\n                    ")])], 1)]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card new-order-box",
    class: {
      'new-order-box--visible': _vm.newOrder
    }
  }, [_c('p', [_vm._v("Kolejność została zmieniona")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.submitOrder
    }
  }, [_vm._v("Zapisz nową kolejność")])], 1), _vm._v(" "), _c('ul', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticClass: "list"
  }, [_c('draggable', {
    attrs: {
      "options": {}
    },
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": _vm.orderChanged
    },
    model: {
      value: (_vm.data),
      callback: function($$v) {
        _vm.data = $$v
      },
      expression: "data"
    }
  }, [_c('transition-group', _vm._l((_vm.data), function(item) {
    return _c('li', {
      key: item.id,
      staticClass: "item"
    }, [_c('span', {
      staticClass: "item__name"
    }, [_vm._v(_vm._s(item.name_pl))]), _vm._v(" "), _c('span', {
      staticClass: "item__icon"
    }, [_c('i', {
      staticClass: "fa fa-align-justify"
    })])])
  }), 0)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fe1378f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Events/EventsOrder.vue
// module id = 733
// module chunks = 0